import React, { useRef, useState } from 'react'

import { Dialog as MuiDialog, DialogContent } from '@material-ui/core'

import createLogger from 'debug'
import { 
    DialogIcon, DialogTitle,
    PaperPlaneIcon, PinIcon,
    WhenNotLoggedIn,
    RequiresRegistration,
 } from 'lib-core'

import {
    Grid as MuiGrid, IconButton, InputAdornment, OutlinedInput,
} from '@material-ui/core'


import styled from 'styled-components'

import { PostNotesList } from './PostNotesList'
import { NoteTypeSelector } from './NoteTypeSelector'
import { useAddNote } from './useAddNote'


// to enable localStorage.debug = 'info:*'
const info = createLogger('info:ui')

const Dialog = styled(MuiDialog)`
  & .MuiDialogContent-root {
    overflow: hidden;
    display: flex;
    flex-direction: column;
 }

 & .MuiList-root {
    overflow-y: auto;
 }
`


export const WriteNoteDialog = ({ open, handleClose }: { open, handleClose }) => {
    const type = useRef<string>()
    const text = useRef<string>()
    const [input, setInput] = useState<string>("")

    const { onClick: addNote, loading } = useAddNote({ type, text, setInput })

    const onNoteTextChange = (e: React.ChangeEvent<HTMLTextAreaElement | HTMLInputElement>) => {
        const value = e.target.value
        text.current = value
        setInput(value)
    }

    const disabled = loading

    const onChangeNoteType = (event, newType) => {
        type.current = newType
    }

    return (
        <Dialog
            onKeyPress={(ev) => {
                if (ev.key === 'Enter') {
                    addNote(ev)
                }
            }}
            onClose={(ev: React.MouseEvent) => {
                ev.stopPropagation()
                handleClose(true)
            }}
            // onClick={(ev: React.MouseEvent) => {
            //     ev.stopPropagation()
            //     handleClose(true)
            // }}>            
            aria-labelledby="customized-dialog-title"
            open={open}
            BackdropProps={{ style: { backgroundColor: "transparent" } }}
        >
            <DialogTitle
                icon={<DialogIcon><PinIcon size={24} /></DialogIcon>}
                id="customized-dialog-title"
                onClose={() => handleClose(true)}>
                Notes
            </DialogTitle>
            <DialogContent dividers>
                <WhenNotLoggedIn logged={(
                    <>
                        <PostNotesList />

                        <NoteTypeSelector onChange={onChangeNoteType} />

                        <OutlinedInput
                            autoFocus
                            value={input}
                            onChange={onNoteTextChange}
                            disabled={disabled}
                            endAdornment={
                                <InputAdornment position="end">
                                    <IconButton
                                        disabled={disabled}
                                        onClick={addNote}
                                    >
                                        <PaperPlaneIcon />
                                    </IconButton>
                                </InputAdornment>
                            }
                        />
                    </>
                )}>
                    <RequiresRegistration />
                </WhenNotLoggedIn>

            </DialogContent>

        </Dialog >
    )
}